import { __assign, __rest } from "tslib";
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { View, Platform } from 'react-native';
import { PnmacMediaQuery, PnmacMeta } from 'pnmac-universal-components';
import { useDispatch } from 'react-redux';
import PaperLessCompile from '../../components/Popups/PaperLess';
import { trackerDispatcher as _trackerDispatcher, authenticate } from '../../redux/actions/actions';
import { useMovrStatus } from './useMovrStatus';
import { AdButler } from './AdButler';
import { PaymentSection } from './PaymentSection';
import { BannerSection } from './BannerSection';
import { PennymacCards } from './PennymacCards';
import { ThirdPartyCards } from './ThirdPartyCards';
import { TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events';
import { BIO_WORKING } from '../../redux/actions/actions';
var QUERY_CONFIG = {
  small: '(max-width: 599px)',
  medium: '(min-width: 600px) and (max-width: 1199px)',
  mediumLarge: '(min-width: 1024px) and (max-width: 1199px)',
  large: '(min-width: 1200px)'
};
var MarLanding = function (_a) {
  var showHomeCards = _a.showHomeCards,
    props = __rest(_a, ["showHomeCards"]);
  var _b = useState({
      long: 0,
      lat: 0,
      imageUrl: '',
      propertyInfo: null,
      inactive: false,
      showBanner: false,
      movrWebStatus: 'Default'
    }),
    state = _b[0],
    setState = _b[1];
  var layout = props.layout,
    translations = props.translations;
  var dispatch = useDispatch();
  var trackerDispatcher = useCallback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return dispatch(_trackerDispatcher.apply(void 0, args));
  }, [dispatch]);
  useEffect(function () {
    if (!(layout === null || layout === void 0 ? void 0 : layout.pennyWise) && (layout === null || layout === void 0 ? void 0 : layout.logedIn) === true) {
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, 'Marketing Landing Pages Viewed', 0);
      if ((layout === null || layout === void 0 ? void 0 : layout.mobile) && (layout === null || layout === void 0 ? void 0 : layout.isAutoLogin)) {
        trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, 'auto login via ' + Platform.OS, 0);
        dispatch({
          type: BIO_WORKING,
          working: false,
          autoLogin: false
        });
      }
    }
  }, []);
  useMovrStatus(layout, state, setState);
  var combinedProps = useMemo(function () {
    return __assign(__assign({}, props), {
      layout: layout,
      translations: translations,
      enabled: !layout.loading,
      trackerDispatcher: trackerDispatcher
    });
  }, [props, layout, translations, layout.loading, trackerDispatcher]);
  return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
    onRefresh: function () {
      return dispatch(authenticate(false));
    },
    refreshing: layout.reloadingData,
    queries: QUERY_CONFIG
  }, function (matches) {
    var _a;
    return /*#__PURE__*/React.createElement(React.Fragment, null, ((_a = layout === null || layout === void 0 ? void 0 : layout.loanPreference) === null || _a === void 0 ? void 0 : _a.length) > 0 && !layout.pennyWise && (/*#__PURE__*/React.createElement(PaperLessCompile, {
      matches: matches
    })), /*#__PURE__*/React.createElement(PnmacMeta, {
      title: layout.isPrivateLabel ? 'My Home' : 'My PennyHome'
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        display: 'flex',
        flexDirection: matches.large ? 'row' : 'column',
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(AdButler, __assign({}, combinedProps)), /*#__PURE__*/React.createElement(BannerSection, __assign({
      state: state,
      matches: matches
    }, combinedProps)), /*#__PURE__*/React.createElement(PaymentSection, __assign({
      matches: matches
    }, combinedProps)), showHomeCards && (/*#__PURE__*/React.createElement(View, {
      style: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: matches.small ? 'column' : 'row',
        flexWrap: 'wrap'
      }
    }, !layout.isPennymac ? (/*#__PURE__*/React.createElement(ThirdPartyCards, __assign({
      matches: matches
    }, combinedProps))) : (/*#__PURE__*/React.createElement(PennymacCards, __assign({
      matches: matches
    }, combinedProps))))))));
  });
};
export default MarLanding;